import React from "react";
import { Flame, Snowflake, Clock, Hash } from "lucide-react";
import { PowerballBall } from "../PowerballBall";
import { Card } from "./FrequencyCharts";

function BallChips({ items, red = false, countClass }) {
  return (
    <div className="flex flex-wrap gap-2">
      {items?.map((h) => (
        <div key={h.num} className="flex items-center gap-2 bg-ink border border-white/5 rounded-lg px-2 py-1.5">
          <PowerballBall n={h.num} red={red} size="sm" />
          <span className={`font-body text-xs ${countClass}`}>×{h.count}</span>
        </div>
      ))}
    </div>
  );
}

function StreakCard({ title, icon, testid, whites, powerballs, whiteClass, pbClass, pbTitle }) {
  return (
    <div className="lg:col-span-6">
      <Card title={title} icon={icon} testid={testid}>
        <BallChips items={whites} countClass={whiteClass} />
        <div className="label-caps mt-4">{pbTitle}</div>
        <div className="mt-2"><BallChips items={powerballs} red countClass={pbClass} /></div>
      </Card>
    </div>
  );
}

export function HotColdCards({ hc }) {
  const window = hc?.window || 30;
  return (
    <>
      <StreakCard title={`Hot Numbers (last ${window} draws)`} icon={Flame} testid="hot-numbers" whites={hc?.hot_whites} powerballs={hc?.hot_powerballs} whiteClass="text-oracle" pbClass="text-pb_red" pbTitle="Hot Powerballs" />
      <StreakCard title={`Cold Numbers (last ${window} draws)`} icon={Snowflake} testid="cold-numbers" whites={hc?.cold_whites} powerballs={hc?.cold_powerballs} whiteClass="text-terminal" pbClass="text-parchment/50" pbTitle="Cold Powerballs" />
    </>
  );
}

export function OverdueCard({ od }) {
  return (
    <div className="lg:col-span-6">
      <Card title="Most Overdue Whites" icon={Clock} testid="overdue-numbers">
        <ul className="divide-y divide-white/5">
          {od?.overdue_whites?.map((o) => (
            <li key={o.num} className="flex items-center justify-between py-2">
              <PowerballBall n={o.num} size="sm" />
              <span className="font-body text-sm text-parchment/70">
                <span className="text-oracle">{o.draws_since}</span> draws since
              </span>
            </li>
          ))}
        </ul>
      </Card>
    </div>
  );
}

export function PairsCard({ pairs }) {
  return (
    <div className="lg:col-span-12">
      <Card title="Top Co-Occurring Pairs" icon={Hash} testid="pairs">
        <div className="flex flex-wrap gap-3">
          {pairs?.top_pairs?.map((p) => (
            <div key={`${p.pair[0]}-${p.pair[1]}`} className="flex items-center gap-2 bg-ink border border-white/5 rounded-lg px-2 py-1.5">
              <PowerballBall n={p.pair[0]} size="sm" />
              <PowerballBall n={p.pair[1]} size="sm" />
              <span className="font-body text-xs text-oracle">×{p.count}</span>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
